import Svg, { Path } from 'react-native-svg'

export const ProfileIconFilled = ({ height = 20, width = 20, color = '#fff' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 3.2a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8Zm0 11.2a6.4 6.4 0 0 1-5.232-2.728C5.568 12.464 7.6 11.6 10 11.6c2.4 0 4.432.864 5.232 2.072A6.4 6.4 0 0 1 10 16.4Z"
      />
    </Svg>
  )
}
